import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { isFetching } from '@mews-commander/legacy-entities/src/ducks/spaces';
import ConnectedPieChart from '../../charts/PieChart/ConnectedPieChart';
import { trackDashboardPieClick } from '../actions/util';
import { getResourceStateValues } from '../selectors/resourceStatistics';
import { navigateToResourceStatusReport } from '../actions/resourceStatusStatistics';

export default connect(
    createStructuredSelector({
        // @ts-expect-error $TSFixMeError: No overload matches this call.
        data: getResourceStateValues,
        showLoader: isFetching,
    }),
    (dispatch) => ({
        onClick: () => {
            // @ts-expect-error $TSFixMeError: Argument of type '(dispatch: $TSFixMe) => void' is not assignable to parameter of type 'Action<any>'.
            dispatch(trackDashboardPieClick('ResourceStatusChart'));
            // @ts-expect-error $TSFixMeError: Argument of type 'ThunkAction<Action<any>, void, ApplicationState>' is not assignable to parameter of type 'Action<any>'...
            dispatch(navigateToResourceStatusReport());
        },
    })
)(ConnectedPieChart);
